import React from 'react';

export const FormGroupContext = React.createContext<{ controlId?: string }>({});
